import { CreateOrganisationPayload } from '../services/adapters/onboardOrganisation';
import { SsoFormState } from '../types/forms.type';
import { getCustomClaimClientsError, parseCustomClaimClients } from './customClaimClients';
import { parseCsvIntegers, parseCsvStrings } from './formatters';

export interface OrganisationOnboardingFormState extends SsoFormState {
  displayName: string;
  calculatorOrgId: string;
  emailDomains: string;
  liftDataIds: string;
  isCampaignEnabled: boolean;
}

type ValidationResult =
  | { ok: true; payload: CreateOrganisationPayload }
  | { ok: false; error: string };

export function buildOnboardingPayload(form: OrganisationOnboardingFormState): ValidationResult {
  if (!form.displayName.trim()) {
    return { ok: false, error: 'Display name is required.' };
  }

  const emailDomains = parseCsvStrings(form.emailDomains);
  if (emailDomains.length === 0) {
    return { ok: false, error: 'At least one email domain is required.' };
  }

  const { values: liftDataIds, invalid } = parseCsvIntegers(form.liftDataIds);
  if (invalid.length > 0) {
    return { ok: false, error: `Invalid lift data IDs: ${invalid.join(', ')}` };
  }

  let calculatorOrgId: number | null = null;
  if (form.calculatorOrgId.trim()) {
    const parsed = Number(form.calculatorOrgId);
    if (!Number.isInteger(parsed) || parsed <= 0) {
      return { ok: false, error: 'Calculator org ID must be a positive integer.' };
    }
    calculatorOrgId = parsed;
  }

  const customClaimClients = parseCustomClaimClients(form.customClaimClients);
  const customClaimClientsError = getCustomClaimClientsError(customClaimClients);
  if (customClaimClientsError) {
    return { ok: false, error: customClaimClientsError };
  }

  return {
    ok: true,
    payload: {
      samlProviderName: form.samlProviderName.trim() || null,
      displayName: form.displayName.trim(),
      calculatorOrgId,
      emailDomains,
      liftDataIds,
      isCampaignEnabled: form.isCampaignEnabled,
      metadataUrl: form.samlSource === 'url' && form.metadataUrl.trim() ? form.metadataUrl.trim() : null,
      xmlMetadata: form.samlSource === 'xml' && form.xmlMetadata.trim() ? form.xmlMetadata : null,
      customClaimClients,
    },
  };
}
